import { CanDeactivate } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SweetAlert, ApiEndpoints, CookieNames, BasicRoutes } from '../../constant';
import swal from 'sweetalert2';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
  getTranslateService: () => TranslateService;
  getPaperPartsInfo: () => any;
  getRouter: () => any;
}

export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> | Promise<boolean> {
    //if there are no pending changes, just allow deactivation; else confirm first
    if (component.getPaperPartsInfo().cookieManagerService.getCookie(CookieNames.loginKey, false)) {
      if (component.canDeactivate()) {
        return true;
      } else {
        return new Promise((resolve, reject) => {
          this.getSwal(component, function (error, returnVal) {
            returnVal == true ? resolve(true) : resolve(false);
          });
        });
      }
    } else {
      return true;
    }
  }

  getSwal(component, callback) {
    swal({
      title: component.getTranslateService().instant("WORNING_HEADER"),
      text: component.getTranslateService().instant("WORNING_BODY"),
      showCancelButton: true,
      timer: component.getPaperPartsInfo().timer,
      confirmButtonClass: 'swal2-confirm-left',
      confirmButtonText: component.getTranslateService().instant("YES"),
      cancelButtonText: component.getTranslateService().instant("BTN_IGNORE"),
      confirmButtonColor: SweetAlert.confermBtnColour,
      cancelButtonColor: SweetAlert.ignoreBtnColour,
    }).then(function () {
      let dataObj = component.getPaperPartsInfo();
      dataObj.httpService.authPostWithSetId(ApiEndpoints.discardChanges, { partid: dataObj.partid, version: dataObj.version }, dataObj.cookieManagerService.getCookie(CookieNames.paperSetKey, false))
        .subscribe(response => {
          callback(null, true);
        }, error => {
          return this.getSwalError(component);
        });
    },
      function (dismiss) {
        if (dismiss === 'cancel') {
          callback(null, false);
        }
      });
  }
  getSwalError(component){
    let dataObj = component.getPaperPartsInfo();
    swal.queue([{
      title: component.getTranslateService().instant("NO_INTERNET_TITLE"),
      confirmButtonText: component.getTranslateService().instant("NOINT_TRY_AGAIN"),
      text: component.getTranslateService().instant("NO_INTERNET_BODY"),
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: function () {
        return new Promise(function (resolve) {
          let interval = setInterval(() => {
            dataObj.httpService.authPostWithSetId(ApiEndpoints.discardChanges, { partid: dataObj.partid, version: dataObj.version }, dataObj.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(
              sucess => {
                clearInterval(interval);
                swal.insertQueueStep({ title: 'Connected!', text: component.getTranslateService().instant("BACK_TO_PAPER"), confirmButtonText: component.getTranslateService().instant("ENTER") })
                resolve();
              }, error => {
                return false;
              })
          }, 3000);
        })
      }
    }])
  }
  
}





// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/services/route-deactivate.ts